import { render, staticRenderFns } from "./admin_edit_personal.vue?vue&type=template&id=753b78de&scoped=true&"
import script from "./admin_edit_personal.vue?vue&type=script&lang=js&"
export * from "./admin_edit_personal.vue?vue&type=script&lang=js&"
import style0 from "./admin_edit_personal.vue?vue&type=style&index=0&id=753b78de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b78de",
  null
  
)

export default component.exports